<div class="medical_team header_top my-5">
    <h6>OUR TEAM</h6>
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_10.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Dr Baiju P. A, Clinical Director</h4>
                        <p>Consultant in Reproductive Endocrinology & ART</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_1.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Dr. Harinath Sagar</h4>
                        <p>Senior consultant in Anaesthesiology</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_11.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Dr. Manoj Kumar T.V </h4>
                        <p>Visiting Consultant in Reproductive Medicine</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_8.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Dr Sreekrishna Kiran</h4>
                        <p>Consultant in Reproductive Medicine</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_12.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Dr Dhanya V</h4>
                        <p>Consultant in Reproductive Medicine & Surgery</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_13.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Dr Neha Haridas</h4>
                        <p>Consultant in Reproductive Medicine</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_3.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Dr Amar Ramachandran</h4>
                        <p>Visiting Consultant in ART</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_2.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Dr Pratheesh Rajendran</h4>
                        <p>Visiting Consultant in ART</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_9.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Dr Shaheen Banu</h4>
                        <p>Consultant in Fetal Maternal Medicine</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_5.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Ms Soorya Gayathri N</h4>
                        <p>Director and Chief Embryologist</p>
                    </div>
                </div>
            </div>



            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_7.webp" alt="">
                    <div class="medical_person_details">
                        <h4> Ms Sherly</h4>
                        <p>Senior Embryologist & ART Co-ordinator</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_6.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Ms Nidhisha A</h4>
                        <p>Counselor in ART</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_4.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Ms Dhanya K.V </h4>
                        <p> Manager</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_14.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Ms Aswathy Ashokan</h4>
                        <p>Assistant Manager</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_15.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Adv. Shija K M</h4>
                        <p>Legal Advisor</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_grp_6.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Department of Clinical Embryology & Andrology</h4>
                        <p></p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_grp_2.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Department of Nursing </h4>
                        <p></p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_grp_8.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Department of Fetal Maternal Medicine </h4>
                        <p></p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_grp_4.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Scan Room Department </h4>
                        <p></p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_grp_5.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Department of Medical Laboratory Services </h4>
                        <p></p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_grp_3.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Department of Pharmacy</h4>
                        <p></p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_grp_1.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Department of Administration</h4>
                        <p></p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="medical_person">
                    <img loading="lazy" src="../../../assets/images/medical_team/medical_team_grp_7.webp" alt="">
                    <div class="medical_person_details">
                        <h4>Department of House Keeping </h4>
                        <p></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>